import { Components, Theme } from '@mui/material';

export const dialogTitleStyles: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '32px',
      mb: '20px',
      color: theme.palette.customGrey.dark
    })
  }
};
